import { useCallback, useContext, useEffect, useReducer, useRef, useState } from "react";
import { ChatContext } from "../../context/ChatContext";
import { AuthContext } from "../../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMessage, faCompass, faGear, faHeart, faMagnifyingGlass, faRightFromBracket, faShirt, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import NavigationReducer, { SET_ACTIVE_VIEW } from "../../reducers/NavigationReducer";
import SearchNavigation from "../../components/searchNavigation/SearchNavigation";
import NotificationNavigation from "../../components/notificationNavigation/NotificationNavigation";
import styles from "./Navigation.module.css";

function Navigation({ isOpen, onOpenChange }) {
  const { unreadCount } = useContext(ChatContext);
  const { signOut } = useContext(AuthContext); const navigate = useNavigate();
  const [internalOpen, setInternalOpen] = useState(false); const drawerRef = useRef(null); const open = isOpen ?? internalOpen;
  const setOpen = useCallback((next) => { if (isOpen === undefined) setInternalOpen(next); onOpenChange?.(next); }, [isOpen, onOpenChange]);
  const closeMenu = useCallback(() => {
    // Remover o foco antes de ocultar o drawer para tecnologias assistivas.
    if (drawerRef.current?.contains(document.activeElement)) {
      document.querySelector('[aria-controls="app-drawer"]')?.focus();
      if (drawerRef.current.contains(document.activeElement)) document.activeElement?.blur();
    }
    setOpen(false);
  }, [setOpen]);
  const [state, dispatch] = useReducer(NavigationReducer, { activeView: null });
  const showView = (view) => dispatch({ type: SET_ACTIVE_VIEW, payload: view });
  const handleSignOut = () => { closeMenu(); signOut(); navigate("/"); };
  useEffect(() => {
    if (!open) return undefined;
    const overflow = document.body.style.overflow; document.body.style.overflow = "hidden";
    drawerRef.current?.querySelector("[data-drawer-item]")?.focus();
    const keydown = (event) => event.key === "Escape" && closeMenu(); document.addEventListener("keydown", keydown);
    return () => { document.body.style.overflow = overflow; document.removeEventListener("keydown", keydown); };
  }, [closeMenu, open]);
  return <div className={`${styles.sideNavBar} ${open ? styles.open : styles.closed}`}>
    {open && <button className={styles.backdrop} onClick={closeMenu} aria-label="Fechar menu" />}
    <aside ref={drawerRef} id="app-drawer" className={styles.drawer} aria-hidden={!open} inert={open ? undefined : ""}>
      <header className={styles.drawerHeader}><img src="/logopreta.png" alt="weDress" /><button type="button" onClick={closeMenu} aria-label="Fechar menu"><FontAwesomeIcon icon={faXmark} /></button></header>
      <div className={styles.navigation}>
        <nav aria-label="Menu complementar"><ul>
          <li><Link to="/messages" onClick={closeMenu}><FontAwesomeIcon icon={faMessage} /><span>Mensagens{unreadCount > 0 ? ` (${unreadCount})` : ""}</span></Link></li>
          <li><Link to="/explore" onClick={closeMenu} data-drawer-item><FontAwesomeIcon icon={faCompass} /><span>Explorar</span></Link></li>
          <li><button type="button" onClick={() => showView(<SearchNavigation />)}><FontAwesomeIcon icon={faMagnifyingGlass} /><span>Pesquisar</span></button></li>
          <li><button type="button" onClick={() => showView(<NotificationNavigation onSelect={closeMenu} />)}><FontAwesomeIcon icon={faHeart} /><span>Notificações</span></button></li>
          <li><Link to="/wardrobe" onClick={closeMenu}><FontAwesomeIcon icon={faShirt} /><span>Meu guarda-roupa</span></Link></li>
          <li><button type="button" disabled title="Em breve"><FontAwesomeIcon icon={faGear} /><span>Configurações <small>Em breve</small></span></button></li>
        </ul></nav>
        {state.activeView && <div className={styles.navigationView}>{state.activeView}</div>}
      </div>
      <footer><Link className={styles.policyLink} to="/termos" onClick={closeMenu}>Termos de uso e privacidade</Link><button type="button" onClick={handleSignOut}><FontAwesomeIcon icon={faRightFromBracket} /><span>Sair</span></button></footer>
    </aside>
  </div>;
}
export default Navigation;
